import { withInstall } from '../utils';
import _Badge from './Badge';
export var Badge = withInstall(_Badge);
export default Badge;